
export const LANG_PREFIX_LIST = ['en', 'es', 'fr', 'de', 'pt', 'nl', 'sv', 'ar', 'iw', 'it', 'ru', 'zh', 'zhtw', 'ko', 'ja', 'th', 'vi', 'id'];

export function getLangPrefixOfPath(excludeLangPrefixList: string[] = []) {
    const path = location.pathname;
    const _langPrefixList = LANG_PREFIX_LIST.filter(e => !excludeLangPrefixList.includes(e));
    const langPrefixPattern = _langPrefixList.join('|');

    const langMatch = path.match(new RegExp(`^/(${langPrefixPattern})(/.+|$)`));
    if (!langMatch) {
        return {langPrefix: null, path: path};
    }
    const langPrefix = langMatch[1];
    const remainingPath = langMatch[2] || '/';

    if (!langPrefix) {
        return {langPrefix: null, path: path};
    }

    return {langPrefix, path: remainingPath};
}

/**
 * 判断是否是支持多语前缀
 */
export function isSupportLangPrefixRoute(path: string): boolean {
    const officialRoutes = [
        "/home",
        "/product",
        "/solution",
        "/download",
        "/overview",
        "/customer-stories",
        "/resources",
        "/cms",
        "/plan/pricing",
    ];
    const result = officialRoutes.some(route => path == route || path.startsWith(route + '/'));
    return result;
}


export function addLangPrefixToUrl(url: string) {
    const { langPrefix } = getLangPrefixOfPath();
    if (!langPrefix) {
        return url;
    }
    if (url.startsWith('http')) {
        const urlObj = new URL(url);
        if (isSupportLangPrefixRoute(urlObj.pathname)) {
            urlObj.pathname = `/${langPrefix}${urlObj.pathname}`;
            return urlObj.toString();
        }
        return url;
    }
    if (url.startsWith('/') && isSupportLangPrefixRoute(url)) {
        return `/${langPrefix}${url}`;
    }
    return url;
}